<template>

  <div
    ref="scroller"
    class="bg-light p-3"
    @scroll="onScroll">
    <div
      v-if="loadingMore"
      class="text-center text-muted py-2">
      <i class="fa-solid fa-circle-notch fa-spin"></i>
    </div>
    <div
      v-if="loading && !messages.length"
      class="text-center text-muted py-4">
      <i class="fa-solid fa-circle-notch fa-spin fa-lg"></i>
    </div>
    <div
      v-else-if="!messages.length"
      class="text-center text-muted py-5">
      {{ $t('No messages yet') }}
    </div>
    <div
      v-for="(group, index) in groups"
      :key="index">
      <MessageDateDivider
        :key="'divider-' + group.key"
        :date="group.date" />
      <MessageBubble
        v-for="message in group.messages"
        :key="message._id"
        :message="message" />
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import MessageBubble from './MessageBubble'
import MessageDateDivider from './MessageDateDivider'

export default {
  name: 'MessageList',
  components: {
    MessageBubble,
    MessageDateDivider
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      prevScrollHeight: null
    }
  },
  computed: {
    // _id of the last message (used to detect a newly appended message)
    lastMessageId () {
      const last = this.messages[this.messages.length - 1]
      return last ? last._id : null
    },
    // group messages by calendar day (messages arrive ascending)
    groups () {
      const groups = []
      let current = null
      this.messages.forEach((message) => {
        const date = message.sent_at || message.created_at
        const key = moment(date).format('YYYY-MM-DD')
        if (!current || current.key !== key) {
          current = { key: key, date: date, messages: [] }
          groups.push(current)
        }
        current.messages.push(message)
      })
      return groups
    }
  },
  watch: {
    // a new message was appended (last _id changed): scroll to the bottom
    lastMessageId () {
      this.$nextTick(() => { this.scrollToBottom() })
    },
    messages () {
      this.$nextTick(() => {
        if (this.prevScrollHeight !== null) {
          // history was prepended: keep the viewport anchored to where it was
          const el = this.$refs.scroller
          el.scrollTop = el.scrollHeight - this.prevScrollHeight
          this.prevScrollHeight = null
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => { this.scrollToBottom() })
  },
  methods: {
    /*
    scrollToBottom
    */
    scrollToBottom () {
      const el = this.$refs.scroller
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    },
    /*
    onScroll
    loads older history near the top, marks the conversation read near the bottom
    */
    onScroll () {
      const el = this.$refs.scroller
      if (el.scrollTop <= 60 && this.hasMore && !this.loadingMore) {
        // remember the current height so we can restore the position after prepend
        this.prevScrollHeight = el.scrollHeight
        this.$emit('load-more')
      }
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
        this.$emit('seen')
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Messaging/thread/MessageList.vue